/**
 * featuredPosts.ts
 *
 * A SMALL, manually-maintained fallback list of recently published posts.
 * Used exclusively by BlogPreview on the homepage to avoid importing the full
 * blogPosts dataset into the main JS bundle (which causes TBT > 1s).
 *
 * UPDATE THIS FILE whenever a new post is published:
 * - Add the new post at the top
 * - Remove the oldest entry (keep exactly 3 posts)
 * - Copy only: slug, title, date, author, tags, heroImage, excerpt
 *
 * Last updated: 2026-10-06
 */

export interface FeaturedPost {
  slug: string;
  title: string;
  date: string;
  author: string;
  tags: string[];
  heroImage: string;
  excerpt: string;
}

export const featuredPosts: FeaturedPost[] = [
  {
    slug: "chatgpt-ads-visual-format-measurement-reasoned-intent-2026",
    title: "ChatGPT Ads Is Moving Beyond the Click. Marketers Need a Reasoned-Intent Measurement Plan.",
    date: "2026-10-06",
    author: "Modi Elnadi",
    tags: ["PPC & Performance Max", "AI Marketing Strategy", "AI News & Trends"],
    heroImage: "/media/chatgpt-ads-visual-format-measurement-reasoned-intent-2026-hero_22653b1a.jpg",
    excerpt: "OpenAI’s announced visual ChatGPT Ads test makes one point clear: a conversational ad interaction is not a conventional pageview. Set eligible events, data rules, consent boundaries and accountable human review before claiming performance.",
  },
  {
    slug: "agentic-traffic-demand-visibility-agent-experience-2026",
    title: "Agentic Traffic Is Becoming a Demand Signal. That Is Not the Same as a Conversion Signal.",
    date: "2026-10-06",
    author: "Modi Elnadi",
    tags: ["Agentic AI", "AEO & AI Search", "AI News & Trends"],
    heroImage: "/media/agentic-traffic-demand-visibility-agent-experience-2026-hero_98b7f349.jpg",
    excerpt: "Observed agentic traffic can reveal an early research signal without proving demand or revenue. Learn how to separate technical requests, agent research, human intent and completed value without weakening consent or transaction controls.",
  },
  {
    slug: "enterprise-ai-agents-knowledge-context-production-2026",
    title: "The Enterprise AI Agent Bottleneck Is Context. Here Is the Commercial Control Layer.",
    date: "2026-10-06",
    author: "Modi Elnadi",
    tags: ["Agentic AI", "AI Governance & Safety", "AI News & Trends"],
    heroImage: "/media/enterprise-ai-agents-knowledge-context-production-2026-hero_ad0b7451.jpg",
    excerpt: "Sponsored research points to enterprise agent context gaps. A vendor-neutral Commercial Context Layer helps teams govern definitions, evidence, permissions, freshness and human approval without treating a platform as a guarantee.",
  },
];
